import { useCallback, useState } from 'react';

import { AppDispatch, removeLabelInImage } from '../../../../store';

interface UseEditLabelUiStateParams {
  dispatch: AppDispatch;
  markerId: string;
  onClose: () => void;
}

export function useEditLabelUiState({
  dispatch,
  markerId,
  onClose,
}: UseEditLabelUiStateParams) {
  const [isGroupManagerOpen, setIsGroupManagerOpen] = useState(false);

  const openGroupManager = useCallback(() => {
    setIsGroupManagerOpen(true);
  }, []);

  const closeGroupManager = useCallback(() => {
    setIsGroupManagerOpen(false);
  }, []);

  const handleDelete = useCallback(() => {
    dispatch(removeLabelInImage(markerId));
    onClose();
  }, [dispatch, markerId, onClose]);

  return {
    isGroupManagerOpen,
    openGroupManager,
    closeGroupManager,
    handleDelete,
  };
}

export default useEditLabelUiState;
